/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { InjectionToken } from '@angular/core';
import { SysqueElectricalState } from '@hcworkspace/sysque/toolbelt/feature';
import { Observable } from 'rxjs';
import { SysQueCategoryOperationsResult, SysQueSystemsOperationsResult } from '../../../../../feature/src/lib/models/sysque-systems-operations';
import { SystemInfo } from '../system-info';
import { TabDescription } from '../tab-description';

export interface IDeleteSystemCategoryFacade {
  removeSystem(nameOfRequest: string, systemName: string): Observable<SysQueSystemsOperationsResult>;
  deleteCategory(requestName: string, categoryName: string, systemName: string): Observable<SysQueCategoryOperationsResult>;
  closeWindow(): void;
  windowResize(height: number): void;
  updateSystemInfo(systems: SystemInfo[], categories: TabDescription[]): void;
  getSystemState(): SysqueElectricalState;
}

export const DELETE_SYSTEM_CATEGORY_FACADE_TOKEN = new InjectionToken<IDeleteSystemCategoryFacade>(
  'DELETE_SYSTEM_CATEGORY_FACADE_TOKEN'
);
